import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import {
	BackwardWelCarousel,
	ForwardWelCarousel,
	SendIconButton,
} from '../../../../../../Components/FeatureComponents/Buttons/IconButton/Icons';
import EcomStarRating from '../../EcomStarRating';
import { Carousel } from 'react-responsive-carousel';
import { getCurrencySymbol } from '../../../../../FlyfishComponents/flyfishutils/utils';
import { AIIcon } from '../../../../../FlyfishComponents/flyfishIcons/icons';
const CarouselContainer = styled.div`
	background-color: var(--colorScale-8);
	padding: 21px;
	position: relative;
	margin-top: 18px;
	> svg {
		position: absolute;
		right: 14px;
		top: 10px;
	}
	> .ff-chatbot-h6 {
		margin-bottom: 17px;
		letter-spacing: 0.5px;
	}
	> .carousel-root {
		height: 100%;
		> .carousel.carousel-slider {
			height: 100%;
		}
	}
	li.slide {
		padding: 4px;
	}
	.carousel .control-dots .dot {
		width: 8px;
		height: 8px;
		box-shadow: none;
		background-color: transparent;
		border: 1.3px solid var(--black-60);
		&.selected {
			background: #000;
		}
	}

	.ff-style-item {
		display: flex;
		cursor: pointer;
		flex-direction: column;
		justify-content: center;
		border-radius: 15px;
		align-items: center;
		background-color: #fff;
		border-radius: 17px;
		min-height: 365px;
		padding: 10px;
		height: 100%;
		> img {
			border-radius: 17px;
			height: 80%;
		}

		> div {
			&:nth-of-type(1) {
				margin-left: 20px;
				display: flex;
				flex-direction: column;
				width: 100%;
				justify-content: flex-start;
				align-items: flex-start;
				margin-top: 10px;
			}
			.ff-chatbot-body1 {
				font-weight: 600;
				line-height: 1.3;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 3;
				-webkit-box-orient: vertical;
				word-break: break-word;
				font-size: 16px;
				overflow: hidden;
				text-align: start;
			}
			.ff-chatbot-h3 {
				font-size: 24px !important;
				> sup {
					font-size: 10px !important;
				}
			}
		}
	}
`;

type Props = {
	customClassName?;
	data;
	handleSubmit;
	onClickStyleAdvisor;
	advisorTitle;
};
const StyleAdvisorCarousel = ({
	customClassName,
	data,
	handleSubmit,
	onClickStyleAdvisor,
	advisorTitle
}: Props) => {
	const [moveClass, setMoveClass] = useState<String>('');
	const [activeIndex, setActiveIndex] = useState(0);
	const [width, setWidth] = useState(window.innerWidth < 900 ? 35 : 75);

	window.addEventListener(
		'resize',
		function (event) {
			if (window.innerWidth < 600) {
				setWidth(75);
			} else {
				setWidth(35);
			}
		},
		true
	);
	useEffect(() => {
		if (window.innerWidth < 600) {
			setWidth(75);
		} else {
			setWidth(35);
		}
	});
	return (
		<CarouselContainer>
			<AIIcon />
			<div className='ff-chatbot-h6'>{advisorTitle}</div>
			<Carousel
				showArrows={true}
				showThumbs={false}
				showStatus={false}
				showIndicators={false}
				emulateTouch={true}
				centerMode={true}
				centerSlidePercentage={width}
				renderArrowNext={(onClickHandler, hasNext) =>
					hasNext && (
						<button
							className={`carouselButtons clickable right `}
							onClick={onClickHandler}
							style={{
								top: 'unset',
								right: '20px',
								bottom: '50%',
							}}
						>
							{/* <ArrowRight /> */}
							<ForwardWelCarousel filledColor={'#000'} fill={'#fff'} />
						</button>
					)
				}
				renderArrowPrev={(onClickHandler, hasPrev) =>
					hasPrev && (
						<button
							className={`carouselButtons clickable left `}
							onClick={onClickHandler}
							style={{
								top: 'unset',
								left: '20px',
								bottom: '50%',
							}}
						>
							{/* <ArrowLeft /> */}
							<BackwardWelCarousel filledColor={'#000'} fill={'#fff'} />
						</button>
					)
				}
			>
				{data
					? data.length &&
					data.map((item) => {
						return (
							<div
								className='ff-style-item'
								onClick={() => {
									onClickStyleAdvisor(item);
								}}
							>
								<img src={item.imageUrl} />
								<div>
									<div
										className='ff-chatbot-body1'
										style={{ fontSize: '16px' }}
									>
										{item.title}
									</div>
									<div style={{ margin: '4px 0px' }}>
										{item.rating && parseInt(item.rating) > 0 ? (
											<EcomStarRating
												userRating={item.rating}
												width={'9'}
												height={'9'}
												customClassName='ff-style-rating'
											/>
										) : null}
									</div>
									{parseInt(item.price) > 0 ? (
										<div
											className='ff-chatbot-h3'
											style={{ color: 'var(--selectedColor)' }}
										>
											<sup style={{ fontSize: '16px', marginRight: '4px' }}>
												{getCurrencySymbol(item.currency)}
											</sup>
											{item.price}
										</div>
									) : null}
								</div>
							</div>
						);
					})
					: Array.from(Array(3)).map((_, i) => {
						return (
							<div className='ff-style-item'>
								<img src='' />
								<div>
									<div
										className='ff-chatbot-body1 animation-character'
										style={{ opacity: '10%' }}
									>
										▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆
									</div>
									<div style={{ margin: '4px 0px', visibility: 'hidden' }}>
										<EcomStarRating
											userRating={3}
											width={'9'}
											height={'9'}
											customClassName='ff-style-rating'
										/>
									</div>
									<div
										className='ff-chatbot-h3'
										style={{
											color: 'var(--selectedColor)',
											visibility: 'hidden',
										}}
									>
										<sup style={{ fontSize: '16px', marginRight: '4px' }}>
											$
										</sup>
										123
									</div>
								</div>
							</div>
						);
					})}
			</Carousel>
		</CarouselContainer>
	);
};

export default StyleAdvisorCarousel;
